module.exports = __webpack_public_path__ + "static/media/Artboard3.16dc549e.png";